import React from 'react';
import MenuButton from './MenuButton';
import {
    GearIcon,
    SelectedComfortableIcon,
    UnSelectedComfortableIcon,
    SelectedNormalIcon,
    UnSelectedNormalIcon,
    SelectedCompactIcon,
    UnSelectedCompactIcon
} from 'assests/GmsIcons';

type SettingsButtonProps = {
    onRowDensityChange: (density: RowDensity) => void;
    isOpen: boolean;
    onToggle: () => void;
    currentDensity?: RowDensity;
}

const SettingsButton = ({ onRowDensityChange, isOpen, onToggle, currentDensity = 'normal' }: SettingsButtonProps) => {

    const handleDensityChange = (density: RowDensity) => {
        onRowDensityChange(density);
        onToggle();
    };

    return (
        <div className="tw-relative">
            <MenuButton
                isOpen={isOpen}
                onToggle={onToggle}
                icon={<GearIcon />}
                label="Settings"
            />

            {isOpen && (
                <div className="tw-absolute tw-z-10 tw-mt-1 tw-right-0 tw-bg-white tw-rounded-md tw-shadow-[0px_4px_9px_0px_rgba(0,0,0,0.25)] tw-border tw-border-zinc-200 tw-min-w-[160px] tw-whitespace-nowrap">
                    <div className="tw-px-2.5 tw-py-2 tw-flex tw-flex-col tw-gap-2.5">

                        <div className="tw-text-blue-950 tw-text-sm">Row Density</div>

                        <div className="tw-flex tw-gap-5">
                            <button
                                onClick={() => handleDensityChange('comfortable')}
                                className="tw-w-6 tw-h-5 tw-flex tw-items-center tw-justify-center"
                                aria-label="Comfortable density"
                            >
                                {currentDensity === 'comfortable'
                                    ? <SelectedComfortableIcon />
                                    : <UnSelectedComfortableIcon />
                                }
                            </button>

                            <button
                                onClick={() => handleDensityChange('normal')}
                                className="tw-w-6 tw-h-5 tw-flex tw-items-center tw-justify-center"
                                aria-label="Normal density"
                            >
                                {currentDensity === 'normal'
                                    ? <SelectedNormalIcon />
                                    : <UnSelectedNormalIcon />
                                }
                            </button>

                            <button
                                onClick={() => handleDensityChange('compact')}
                                className="tw-w-6 tw-h-5 tw-flex tw-items-center tw-justify-center"
                                aria-label="Compact density"
                            >
                                {currentDensity === 'compact'
                                    ? <SelectedCompactIcon />
                                    : <UnSelectedCompactIcon />
                                }
                            </button>
                        </div>
                    </div>
                    <div className="tw-w-full tw-h-px tw-bg-gray-200"></div>
                    <div className="tw-px-2.5 tw-py-2 tw-text-blue-950 tw-text-sm tw-whitespace-nowrap">Column Configuration</div>
                </div>
            )}
        </div>
    );
}

SettingsButton.displayName = 'SettingsButton';

export default SettingsButton;